import { SPRINT_OUTCOME_STATUSES } from 'features/planning/config';
import { SprintOutcome, SprintOutcomeStatus } from 'features/planning/types';

type OutcomeProgress = {
  completed: number;
  total: number;
  percentage: number;
};

const STATUS_WEIGHTS: Record<SprintOutcomeStatus, number> = {
  [SPRINT_OUTCOME_STATUSES.NOT_STARTED]: 0,
  [SPRINT_OUTCOME_STATUSES.IN_PROGRESS]: 0.5,
  [SPRINT_OUTCOME_STATUSES.DEPRIORITIZED]: 0,
  [SPRINT_OUTCOME_STATUSES.FAILED]: 0,
  [SPRINT_OUTCOME_STATUSES.COMPLETE]: 1,
};

/**
 * Calculates the progress of sprint outcomes with weighted status values
 * @param sprintOutcomes - Array of sprint outcomes
 * @returns Object containing completed count, total count, and percentage
 */
export const calculateOutcomeProgress = (
  sprintOutcomes: SprintOutcome[]
): OutcomeProgress => {
  const total = sprintOutcomes.length;

  if (total === 0) {
    return {
      completed: 0,
      total: 0,
      percentage: 0,
    };
  }

  const weightedSum = sprintOutcomes.reduce(
    (sum, outcome) => sum + STATUS_WEIGHTS[outcome.status] || 0,
    0
  );

  const percentage = Math.round((weightedSum / total) * 100);

  const completed = sprintOutcomes.filter(
    (outcome) => outcome.status === SPRINT_OUTCOME_STATUSES.COMPLETE
  ).length;

  return {
    completed,
    total,
    percentage,
  };
};
